import { PageHeader } from "@/components/app/PageHeader/PageHeader";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ProfileForm } from "./components/ProfileForm";
import { AvatarForm } from "./components/AvatarForm";

const ProfilePage: React.FC = () => {
	return (
		<div className="container max-w-screen-lg py-6">
			<PageHeader
				title="プロフィール設定"
				description="プロフィール情報の確認と編集ができます"
			/>
			<Tabs defaultValue="profile" className="mt-6">
				<TabsList>
					<TabsTrigger value="profile">基本情報</TabsTrigger>
					<TabsTrigger value="avatar">プロフィール画像</TabsTrigger>
				</TabsList>
				<TabsContent value="profile">
					<Card>
						<CardHeader>基本情報</CardHeader>
						<CardContent>
							<ProfileForm />
						</CardContent>
					</Card>
				</TabsContent>
				<TabsContent value="avatar">
					<Card>
						<CardHeader>プロフィール画像</CardHeader>
						<CardContent>
							<AvatarForm />
						</CardContent>
					</Card>
				</TabsContent>
			</Tabs>
		</div>
	);
};

export default ProfilePage;
